"use client"

import { useState } from "react"
import styles from "./ProcessSteps.module.css"

export default function ProcessSteps({
  title = "Process Of Autologous Micrograft",
  steps = [
    {
      id: "before",
      label: "Before",
      content: (
        <ul>
          <li>Your treatment begins with a detailed scalp and hair follicle analysis by our specialists.</li>
          <li>No special preparation is needed, but we recommend avoiding alcohol and smoking 48 hours prior to your appointment.</li>
          <li>If you are on blood thinners or skin-related medication, please consult your doctor in advance.</li>
          <li>Wash your hair with a gentle, residue-free shampoo on the morning of the procedure.</li>
        </ul>
      ),
      image: "/placeholder-before.jpg"
    },
    {
      id: "during",
      label: "During",
      content: (
        <ul>
          <li>Local anesthesia is administered to ensure your comfort throughout the procedure.</li>
          <li>Healthy hair follicles are carefully extracted from your donor area using advanced micrografting techniques.</li>
          <li>The extracted follicles are prepared and transplanted into the target areas with precision.</li>
          <li>The entire procedure typically takes 30-60 minutes, depending on the scope of treatment.</li>
        </ul>
      ),
      image: "/placeholder-during.jpg"
    },
    {
      id: "after",
      label: "After",
      content: (
        <ul>
          <li>You'll receive detailed post-procedure care instructions from our medical team.</li>
          <li>Mild redness and swelling are normal and should subside within a few days.</li>
          <li>Avoid strenuous activities and direct sun exposure for the first week.</li>
          <li>Follow-up appointments will be scheduled to monitor your healing progress.</li>
        </ul>
      ),
      image: "/placeholder-after.jpg"
    }
  ]
}) {
  const [activeStep, setActiveStep] = useState("before")
  
  const currentStep = steps.find(step => step.id === activeStep) || steps[0]
  const titleParts = title.split(" Of ")

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.contentWrapper}>
          <div className={styles.title}>
            <span className={styles.titleText1}>{titleParts[0]} </span>
            <span className={styles.titleText2}>{titleParts[1]} </span>
          </div>

          <div className={styles.contentGrid}>
            <div className={styles.leftPanel}>
              <div className={styles.tabs}>
                {steps.map((step) => (
                  <button
                    key={step.id}
                    className={`${styles.tab} ${activeStep === step.id ? styles.active : ''}`}
                    onClick={() => setActiveStep(step.id)}
                  >
                    {step.label}
                  </button>
                ))}
              </div>
              
              <div className={styles.content}>
                {currentStep.content}
              </div>
            </div>

            <div className={styles.rightPanel}>
              <img 
                src={currentStep.image} 
                alt={`${currentStep.label} stage`}
                className={styles.stepImage}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
